const $document = $(document);
$document.on('click', '[data-trigger-event]', (event) => {
  event.preventDefault();
  const $item = $(event.currentTarget);
  const eventName = $item.data('trigger-event');
  const eventData = $item.data('event-data');

  $document.trigger(eventName, eventData);
});

function ready(fn) {
  if (document.readyState !== 'loading') {
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    // @ts-ignore
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState !== 'loading') fn();
    });
  }
}

Object.assign(window.storeTheme, {
  helpers: Object.assign(window.storeTheme.helpers || {}, {
    events: {
      ready,
    },
  }),
});

export default {};
